import './breadcrumbs.scss';

const breadcrumbs = () => {

};

export default breadcrumbs;